import React, { memo } from "react";

const Anchor = ({ href, label }: { href?: string; label?: string }) => (
	<a href={href} target="_new" className="focus:outline-none text-current hover:bg-transparent">
		{label}
	</a>
);

export default memo(Anchor);
